import { labeled, stringRequired } from '../../util/joi';

export const assetFinanceSchema = (Joi: any, label: string) =>
  Joi.object().keys({
    notes: stringRequired(Joi, 1, 4096).label(
      labeled(label, 'Primary reason for seeking credit')
    )
  });

export const homeLoanSchema = (Joi: any, label: string) =>
  assetFinanceSchema(Joi, label).keys({
    immediateNeedsAndObjectivesNotes: stringRequired(Joi, 1, 4096).label(
      labeled(
        label,
        'Immediate Needs & Objectives - within the next two years (e.g. holiday, purchases, renovations, savings, protect the family etc.)'
      )
    ),
    longerTermNotes: stringRequired(Joi, 1, 4096).label(
      labeled(
        label,
        'Longer term – between 2 to 10 yearsʼ time (e.g. repay mortgage, buy a new car, education expenses, purchase investment property, retirement planning etc.)'
      )
    )
  });

export default {
  assetFinanceSchema,
  homeLoanSchema
};
